<mat-card>
  <mat-card-header>
    <mat-card-title>Authentication</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form (ngSubmit)="onSubmit()" [formGroup]="form">
      <ui-form-text [data]="userTokenConfig()" formControlName="userToken"></ui-form-text>
      <ui-form-autocomplete [data]="customerNumberConfig()" formControlName="customerNumber"></ui-form-autocomplete>
      <ui-form-submit [data]="submitConfig"></ui-form-submit>
    </form>
  </mat-card-content>
</mat-card>
